import { getGraphqlClient } from "@/api/graphql/client.ts";
import type {
  LedgersMsSearchGroupsRequest,
  LedgersMsSearchGroupsResponse,
} from "@/api/graphql/types/graphql.ts";

import { searchGroupsQuery } from "./queries.ts";

export const searchGroups = async (
  request: LedgersMsSearchGroupsRequest,
): Promise<{ LedgersMsSearchGroups: LedgersMsSearchGroupsResponse }> => {
  const graphqlClient = getGraphqlClient();

  return (await graphqlClient.request(searchGroupsQuery as any, {
    request,
  })) as { LedgersMsSearchGroups: LedgersMsSearchGroupsResponse };
};
